<template>
  <v-menu bottom left offset-y
          origin="top right" transition="scale-transition">
    <template v-slot:activator="{ attrs, on }">
      <v-btn class="ml-2" min-width="0"
             text v-bind="attrs" v-on="on">
        <v-badge bordered :color="notificacoes.length > 0 ? 'primary' : 'clean'" overlap>
          <template v-slot:badge>
            <span>{{ notificacoes.length }}</span>
          </template>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-if="notificacoes.length > 0" v-for="(n, i) in notificacoes" :key="i">
        <v-list-item-title>
          <v-tooltip left color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="n.status === 0"
                      class="pb-1 hover-color"
                      v-bind="attrs" v-on="on"
                      @click="marcarComoLido(n)">
                mdi-eye
              </v-icon>
            </template>
            <span>Marcar como lido</span>
          </v-tooltip>
          <v-tooltip left color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="pb-1 hover-color"
                      v-bind="attrs" v-on="on"
                      @click="deletarNotificacao(n)">
                mdi-close
              </v-icon>
            </template>
            <span>Remover notificação</span>
          </v-tooltip>
          {{ n.conteudo }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="notificacoes.length === 0">
        <v-list-item-title>
          Nenhuma notificação
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {get} from 'vuex-pathify'
import NotificacaoService from "../../../service/notificacao.service";

export default {
  name: 'DefaultNotifications',

  methods: {
    async getNotificacoesUsuario() {
      await NotificacaoService.getNotificacoesUsuario(this.idUsuario);
    },
    async marcarComoLido(n) {
      await NotificacaoService.marcarComoLido(n.id);
      await this.getNotificacoesUsuario();
    },
    async deletarNotificacao(n) {
      await NotificacaoService.deletarNotificacao(n.id);
      await this.getNotificacoesUsuario();
    }
  },
  computed: {
    idUsuario: get('auth/id'),
    notificacoes: get('notificacao/notificacoes')
  },
  async mounted() {
    await this.getNotificacoesUsuario();
  }
}
</script>

<style>
.hover-color:hover {
  color: #008597;
}
</style>
